import React from "react";
import { Route } from "react-router-dom";
import Upload from "../pages/ProducaoEP/upload";
import Relatorio1 from "../pages/ProducaoEP/relatorio1";
import Relatorio2 from "../pages/ProducaoEP/relatorio2";
import Relatorio3 from "../pages/ProducaoEP/relatorio3";
import Relatorio4 from "../pages/ProducaoEP/relatorio4";
import Relatorio5 from "../pages/ProducaoEP/relatorio5";
import Exports from "../pages/ProducaoEP/exports";
import GraficosPage from "../pages/ProducaoEP/graficos";
import IndexTesteNovoJSON from "../Components/ProducaoEP/Realizado/TesteNovoJSON/Index";
import Index from "../pages/ProducaoEP/index";

// Rotas do domínio Produção EP. Exporta só a lista de elementos <Route>
// (sem <BrowserRouter>/<Switch> próprios) para serem montadas dentro do único
// <Switch> consolidado em pages/Principal/index.js (Fase 5).
const routesProducaoEP = [
    <Route key="producaoep-home" exact path="/producaoep" component={Index} />,
    <Route key="producaoep-upload" exact path="/producaoep/upload" component={Upload} />,
    <Route key="producaoep-relatorio1" exact path="/producaoep/relatorio1" component={Relatorio1} />,
    <Route key="producaoep-relatorio2" exact path="/producaoep/relatorio2" component={Relatorio2} />,
    <Route key="producaoep-relatorio3" exact path="/producaoep/relatorio3" component={Relatorio3} />,
    <Route key="producaoep-relatorio4" exact path="/producaoep/relatorio4" component={Relatorio4} />,
    <Route key="producaoep-relatorio5" exact path="/producaoep/relatorio5" component={Relatorio5} />,
    <Route key="producaoep-exports" exact path="/producaoep/exports" component={Exports} />,
    <Route key="producaoep-graficos" exact path="/producaoep/graficos" component={/*IndexTesteNovoJSON*/GraficosPage} />
];

export default routesProducaoEP;
